import { render, staticRenderFns } from "./signIn.vue?vue&type=template&id=52a04524&scoped=true"
import script from "./signIn.vue?vue&type=script&lang=js"
export * from "./signIn.vue?vue&type=script&lang=js"
import style0 from "./signIn.vue?vue&type=style&index=0&id=52a04524&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a04524",
  null
  
)

export default component.exports